<div [dir]="Direction">
  <app-header />
  <div class="container mt-4">
    <div class="row">
      <div class="col-md-12">
        @if (showAlert) {
        <div class="alert alert-success" role="alert">
          {{ "translations.addedToCart" | translate }}
          {{ currentLang === "ar" ? product?.nameAr : product?.name }}
          <button
            type="button"
            class="close"
            aria-label="Close"
            (click)="hideAlert()"
          >
            <!--  -->
            <span aria-hidden="true" class="btn btn-close"> </span>
          </button>
        </div>
        }
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="main-image">
            <img
              [src]="apiURL + mainImage"
              alt="Main Product Image"
              class="img-fluid"
            />
          </div>
          @if (itemPictures.length > 0) {
          <div class="thumbnails mt-3">
            @for (picture of itemPictures; track $index) {
            <img
              [src]="apiURL + picture.path"
              [alt]="'Thumbnail ' + picture.inItemPictureID"
              class="img-thumbnail mr-2"
              (click)="updateMainImage(picture.path!)"
            />
            }

            <!-- (click)="updateMainImage(picture.path)" -->
          </div>
          }
        </div>

        <!-- Product Details -->
        <div class="col-md-6">
          <div class="product-info p-4">
            @if (product?.newArrival) {
            <div class="mb-3">
              <span class="badge badge-new">{{
                "translations.new" | translate
              }}</span>
            </div>
            }

            <!-- Product Title -->
            <h3 class="mb-4">
              {{ currentLang === "ar" ? product?.nameAr : product?.name }}
            </h3>

            <!-- Price Section -->
            <div class="mb-4">
              @if (product?.activateWebDiscount) {
              <h6 class="text-decoration-line-through mb-2">
                {{ "translations.currency" | translate }}
                {{ product?.salesPrice }}
              </h6>
              <h4 class="product-price">
                {{ "translations.currency" | translate }}
                {{
                  (product?.webDiscountAmount || 0)
                }}
              </h4>
              } @else {
              <h4 class="product-price">
                {{ "translations.currency" | translate }}
                {{ product?.salesPrice }}
              </h4>
              }
            </div>

            <!-- Product Description -->
            <p class="mb-4">
              {{
                currentLang === "ar"
                  ? product?.descriptionAr
                  : product?.description
              }}
            </p>

            <!-- Product Details List -->
            <ul class="product-details mb-4">
              <li
                class="mb-2"
                *ngFor="let detail of productDetails; let i = index"
              >
                {{ detail }}
              </li>
            </ul>

            <!-- Quantity Selector -->
            <div class="mb-4">
              <label>{{ "translations.quantity" | translate }}</label>
              <div class="input-group" style="max-width: 200px">
                <div class="input-group-prepend">
                  <button class="btn btn-light border" (click)="decrease()">
                    -
                  </button>
                </div>
                <input
                  type="text"
                  class="form-control text-center"
                  [value]="totalItems"
                  readonly
                />
                <div class="input-group-append">
                  <button class="btn btn-light border" (click)="increase()">
                    +
                  </button>
                </div>
              </div>
            </div>

            <!-- Add to Cart Button -->
            <div class="mb-4">
              <button class="btn btn-dark w-100" (click)="addToCart()">
                {{ "translations.addtocart" | translate }}
              </button>
            </div>

            <!-- Product Features -->
            <ul class="product-icons list-unstyled mt-4">
              <li class="mb-3">
                <fa-icon [icon]="faRocket" class="mx-2" />
                {{ "translations.FastDelivery" | translate }}
              </li>
              <li class="mb-3">
                <fa-icon [icon]="faSlidersH" class="mx-2" />
                {{ "translations.ModernDistinctive" | translate }}
              </li>
              <!--<li class="mb-3">
                <fa-icon [icon]="faIdCard" class="mx-2" />
                {{ "translations.MaterialGuarantee" | translate }}
              </li>-->
              <!--<li class="mb-3">
                <fa-icon [icon]="faUndo" class="me-2" />
                {{ "translations.DaysReturn" | translate }}
              </li>-->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <section class="container mt-5">
      <h2 class="section-title">
        {{ "translations.relatedProducts" | translate }}
      </h2>
      <div class="row">
        <div
          class="col-md-4 col-sm-6"
          *ngFor="
            let product of allproducts | slice : 0 : 3;
            let i = index;
            trackBy: trackByFn
          "
        >
          <div
            class="product-card"
            [routerLink]="['/products', categoryId, 'item', product.inItemID]"
            (click)="navigateToProduct(product.inItemID)"
          >
            <img
              [src]="apiURL + product.photoPath"
              [alt]="'Thumbnail ' + (i + 1)"
              class="img-thumbnail mr-2"
            />
          </div>
          <h3 class="product-title">
            {{ currentLang === "ar" ? product.nameAr : product.name }}
          </h3>
          <p class="product-price">
            {{ product.salesPrice }} {{ "translations.currency" | translate }}
          </p>
        </div>
      </div>
    </section>
  </div>
  <app-footer />
</div>
